export const ALGORITHMS_CURRENTLY_RUNNING: string = 'Algorithms currently running';
export const ALGORITHMS_FINISHED_RUNNING: string = 'Algorithms finished running';
export const START_ONBOARDING: string = 'Start onboarding';
export const UPDATE_YOUR_CARE_SUPPORT_STRUCTURE: string = 'Update your care support structure';
export const COMPLETED_PLAN: string = 'Completed Plan';
export const ALGORITHMS_ERROR: string = 'Algorithms error';
export const CLIENT_STARTED_REVIEW: string = 'Client started review';
export const CLIENT_COMPLETED_REVIEW: string = 'Client completed review';
export const STARTED_REVIEW_TOGETHER: string = 'Review started together';
export const COMPLETED_REVIEW_TOGETHER: string = 'Review completed together';
export const REVIEW_CALL_SCHEDULED: string = 'Review call scheduled';
export const INTAKE_FORM_INCOMPLETE: string = 'Intake form incomplete';
export const STARTED_INTAKE_FORM: string = 'Started intake form';
export const REQUESTED_MEETING: string = 'Requested meeting';
export const REPRESENTATIVE_ASSIGNED: string = 'Representative assigned';
export const INITIAL_CONTACT_MADE: string = 'Initial contact made';

export const CLOSING_THE_CARE_GAP: string = 'Closing the care gap';
export const FILL_OUT_THE_INTAKE_FORM: string = 'Fill out the intake form';

export const OBSOLETE_INTAKE_FORM_IN_PROGRESS: string = 'Intake form in progress';
export const OBSOLETE_PENDING_ONBOARDING: string = 'Pending onboarding';
export const OBSOLETE_PROGRESS_ON_ONBOARDING: string = 'Progress on onboarding';
export const OBSOLETE_PROGRESS_ON_OPPORTUNITIES: string = 'Progress on opportunities';
export const OBSOLETE_FINISHED_ONBOARDING: string = 'Finished onboarding';

export const USER_AVAILABLE_STATUS_TAGS = [
  STARTED_REVIEW_TOGETHER,
  COMPLETED_REVIEW_TOGETHER,
  REVIEW_CALL_SCHEDULED,
  REQUESTED_MEETING,
  REPRESENTATIVE_ASSIGNED,
  INITIAL_CONTACT_MADE,
];

export const ERROR_OR_INCOMPLETE_STATUS_TAGS = [
  ALGORITHMS_ERROR,
  INTAKE_FORM_INCOMPLETE,
  STARTED_INTAKE_FORM,
  ALGORITHMS_CURRENTLY_RUNNING,
];

export const defaultChartColors = [
  '#a798e5',
  '#3d1c7c',
  '#120F3A',
  '#101336',
  '#7CCB6F',
  '#EB3447',
  '#F7C845',
];

export const ACTION_TAG_TOOLTIPS: any = {
  [STARTED_INTAKE_FORM]: <>Client has started their intake form.</>,
  [INTAKE_FORM_INCOMPLETE]: <>Client has not completed their intake form.</>,
  [FILL_OUT_THE_INTAKE_FORM]: <>Client has not completed their intake form.</>,

  [ALGORITHMS_CURRENTLY_RUNNING]: (
    <>
      We&apos;re currently running your client&apos;s Long Term Care projections, please wait for
      the action tag to turn into ”Algorithms finished running“.
    </>
  ),

  [ALGORITHMS_FINISHED_RUNNING]: <>Results are in! Click on the client name to view results.</>,

  [START_ONBOARDING]: (
    <>Client can now start onboarding. Click on the client name to view results.</>
  ),

  [CLOSING_THE_CARE_GAP]: (
    <>
      Care gap refers the care hours that are not covered by members on your support structure
      table. You can close this care gap by adding new members to your table or clicking the edit
      icons on any of your current members and increasing the care hours or care years.
    </>
  ),

  [UPDATE_YOUR_CARE_SUPPORT_STRUCTURE]: (
    <>
      Updating your care support structure refers to editing the care hours that are covered by
      members on your support structure table. You can delete, add, or edit any of your current
      members&apos; care hours or care years provided to you.
    </>
  ),

  [COMPLETED_PLAN]: (
    <>Congratulations on completing your plan and being prepared for your Long Term Care needs.</>
  ),

  [OBSOLETE_INTAKE_FORM_IN_PROGRESS]: (
    <>
      You or the client have yet to fill out the Intake Form. Please complete the form in order to
      access your client&apos;s Long Term Care projection needs and planning tools.
    </>
  ),

  [OBSOLETE_PENDING_ONBOARDING]: (
    <>
      We were able to successfully get outputs from all the relevant algorithms, and we&apos;ll
      review the updated projections in the client profile.
    </>
  ),

  [OBSOLETE_PROGRESS_ON_ONBOARDING]: (
    <>
      We were able to successfully get outputs from all the relevant algorithms, and we&apos;ll
      review the updated projections in the client profile.
    </>
  ),

  [OBSOLETE_PROGRESS_ON_OPPORTUNITIES]: (
    <>
      Care gap refers the care hours that are not covered by members on your support structure
      table. You can close this care gap by adding new members to your table or clicking the edit
      icons on any of your current members and increasing the care hours or care years.
    </>
  ),

  [OBSOLETE_FINISHED_ONBOARDING]: (
    <>Congratulations on completing your plan and being prepared for your Long Term Care needs.</>
  ),

  [ALGORITHMS_ERROR]: (
    <>
      Please click Refresh. If the issue persists, our support team will be notified and will start
      working on a resolution. Check back shortly.{' '}
    </>
  ),

  [CLIENT_STARTED_REVIEW]: <>Client has started reviewing their onboarding results. </>,

  [CLIENT_COMPLETED_REVIEW]: (
    <>Client has reviewed all of their onboarding results and has completed onboarding. </>
  ),
  [STARTED_REVIEW_TOGETHER]: (
    <>You and the client have started reviewing onboarding results together. </>
  ),
  [COMPLETED_REVIEW_TOGETHER]: (
    <>You and the client have completed reviewing onboarding results together. </>
  ),
  [REVIEW_CALL_SCHEDULED]: <>A review call has been scheduled with the client. </>,
  [REQUESTED_MEETING]: <>Client has requested a meeting. </>,
  [REPRESENTATIVE_ASSIGNED]: <>A representative has been assigned to the client. </>,
  [INITIAL_CONTACT_MADE]: <>An initial contact has been made with the client. </>,
};

export const WATERLILY_SQUARE_LOGO_WHITE_URL =
  'https://dvbywcjryswvq.cloudfront.net/W_Square_WHITE.png';

export const WATERLILY_SQUARE_LOGO_DARK_URL =
  'https://dvbywcjryswvq.cloudfront.net/W_Square_PURPLE.png';

export const WATERLILY_LOGO_DARK_PURPLE_URL =
  'https://dvbywcjryswvq.cloudfront.net/Waterlily_logo_darkpurple.png';

export const SALESFORCE_SETUP_GUIDE_URL =
  'https://help.waterlily.com/en/articles/16019665-how-to-connect-your-waterlily-account-to-salesforce';

export const DEV_DOCUSIGN_INTEGRATION_KEY = '3afd5ae9-c575-4992-af81-707bf21735c3';
export const PROD_DOCUSIGN_INTEGRATION_KEY = '3afd5ae9-c575-4992-af81-707bf21735c3';

export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51KfphOCrvzKtEHNdmMRWLp8jbAloPAteofiGkzxAhsnW1rBkEVeuXOopTodXptc9CDSDwV2eyoMAcvhlKfYyf3Yj00XFH2q60D';
export const DEV_STRIPE_PUBLISHABLE_KEY = 'pk_test_51KfphOCrvzKtEHNdQVZlRmbmysvS28aBska3gN8KRVYToXHxpdPLO8bCTJHtmwwotM1cb3CSGmJJJAeROTh3LAuN00RgzMGje1';

export const INSURANCE_SHOPPING_CONFIG = {
  //removed WA due to tighten residency proofing requirements
  allowedStates: new Set([
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'FL',
    'LA',
    'MA',
    'ME',
    'MD',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ]),
  eligibilityAge: {
    min: 40,
    max: 75,
  },
  groupPolicyAge: {
    agisMax: 75,
  },
};

export type AccountType =
  | 'Roth IRA'
  | 'Roth 401(k)'
  | 'Traditional IRA'
  | 'Traditional 401(k)'
  | 'HSA Account'
  | 'Brokerage Account'
  | 'Home Equity'
  | 'Retirement Income';

export interface AssetOption {
  type: LtcFinancialPlanningAssetType;
  label: AccountType;
}

export const ASSET_OPTIONS: AssetOption[] = [
  { type: 'rothIra', label: 'Roth IRA' },
  { type: 'roth401k', label: 'Roth 401(k)' },
  { type: 'traditionalIra', label: 'Traditional IRA' },
  { type: 'traditional401k', label: 'Traditional 401(k)' },
  { type: 'hsa', label: 'HSA Account' },
  { type: 'brokerage', label: 'Brokerage Account' },
  { type: 'homeEquity', label: 'Home Equity' },
  { type: 'retirementIncome', label: 'Retirement Income' },
];

export interface FundingPortionOption {
  value: number;
  label: string;
}

export const FUNDING_PORTION_OPTIONS: FundingPortionOption[] = [
  { value: 100, label: 'All' },
  { value: 50, label: 'Half' },
  { value: 25, label: 'Some' },
  { value: 0, label: 'None' },
];
